<div class="row my-2">
    <div class="col-lg-12">
        <div class="card py-10">
          <div class="row">
            <div class=" mb-2 col-lg-12 px-5">
                <div  style="height: 50px;">
                    <div class="skeleton-card" ></div>
                </div>
            </div>
            <div class=" mb-2 col-lg-12 px-5">
                <div  style="height: 50px;">
                    <div class="skeleton-card" ></div>
                </div>
            </div>
            <div class=" mb-2 col-lg-12 px-5">
                <div  style="height: 50px;">
                    <div class="skeleton-card" ></div>
                </div>
            </div>
            <div class=" mb-2 col-lg-12 px-5">
                <div  style="height: 50px;">
                    <div class="skeleton-card" ></div>
                </div>
            </div>
            
           
          </div>
        </div>
    </div>
</div>